import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Segment } from 'app/core/interfaces';
import { debounceTime } from 'rxjs/operators';
import { SegmentApi } from '../../../api/segments.api';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SegmentsComponent),
  multi: true,
};

@Component({
  selector: 'segments',
  templateUrl: './segments.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
})
export class SegmentsComponent implements ControlValueAccessor, OnInit {
  @Input() disabled: boolean;
  @Input() required = true;
  @Input() appearance = 'outline';
  @Input() segmentValue = false;
  @Input() limit = 50;

  public selectedSegment: Segment;
  public segments: Array<Segment> = [];
  public selectValue: FormControl = new FormControl();

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private segmentsApi: SegmentApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.selectValue.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
      if (value){
        this.onChange(value);
      }
    });
  }

  ngOnInit(): void {
    this.searchSegments();

    if (this.disabled) {
      this.selectValue.disable();
    }
    if (this.required) {
      this.selectValue.setValidators(Validators.required);
    }
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  searchSegments(): void {
    const query =  {
      archived: false
    };

    const options =  {
      orderColumn: 'name',
      order: 'asc',
      limit: this.limit
    };

    this.segmentsApi.search(query, options).subscribe((result) => {
      this.segments = result.items;

        if (this.selectValue.value) {
          const currentSegmentIsOnList = this.segments.some((segment) => {
            return segment.id === this.selectValue.value.id;
          });

          if (!currentSegmentIsOnList) {
            this.segments.push(this.selectValue.value);
          }
        }
    });
  }

  writeValue(segment: Segment): void {
    this.selectValue.setValue(segment);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.selectValue.disable();
    } else {
      this.selectValue.enable();
    }
  }
}
